import { io } from 'socket.io-client';
import Helper from '@/helpers/helper';


// Remplace par ton URL backend Socket.IO

const token = Helper.clientToken();


const socket = io(Helper.api_url, {
    transports: ['websocket'],
    reconnectionAttempts: Infinity,
    autoConnect: true,
    extraHeaders: {
      Authorization: `Bearer ${token}`,
    },
    auth: {
      token: `Bearer ${token}`,
    },
  });


  // Événement déclenché à la connexion réussie
socket.on('connect', () => {
  console.log('✅ Socket connecté avec l’ID :', socket.id);   
});

// Événement déclenché en cas d’erreur de connexio

socket.on('disconnect', (error) => {
  console.error('❌ Socket disconnect :', error.message);
});



export default socket;